/**
 * Checks whether the last argument is a plain options object with `force: true`.
 * Returns { force, cleanArgs } where cleanArgs has the options object stripped.
 */
function extractOptions(args) {
  if (args.length === 0) return { force: false, cleanArgs: args };
  const last = args[args.length - 1];
  if (
    last !== null &&
    typeof last === "object" &&
    !Array.isArray(last) &&
    last.force === true
  ) {
    return { force: true, cleanArgs: args.slice(0, -1) };
  }
  return { force: false, cleanArgs: args };
}

/**
 * Dev-only log. Passes through to console.log.
 * Pass { force: true } as the last argument to fire in all environments.
 * Always returns null (JSX-safe).
 */
export function log(...args) {
  const { force, cleanArgs } = extractOptions(args);
  if (force || process.env.NODE_ENV === "development") {
    console.log(...cleanArgs);
  }
  return null;
}

/**
 * Dev-only warning. Passes through to console.warn.
 * Pass { force: true } as the last argument to fire in all environments.
 * Always returns null (JSX-safe).
 */
export function warn(...args) {
  const { force, cleanArgs } = extractOptions(args);
  if (force || process.env.NODE_ENV === "development") {
    console.warn(...cleanArgs);
  }
  return null;
}

/**
 * Dev-only error. Passes through to console.error.
 * Pass { force: true } as the last argument to fire in all environments.
 * Always returns null (JSX-safe).
 */
export function error(...args) {
  const { force, cleanArgs } = extractOptions(args);
  if (force || process.env.NODE_ENV === "development") {
    console.error(...cleanArgs);
  }
  return null;
}

/** Namespace object — identical to named exports. */
const logger = { log, warn, error };

export default logger;